import HTTP_GESCOM from '../HTTP_GESCOM';

const URL_BASE = 'gescom/LigneCommandeRecommandationDevis/';

export async function getAll(devisId) {
  const response = await HTTP_GESCOM.get(URL_BASE + 'GetAllAsync', { params: { devisId } });
  return response;
}

export async function createAllAsync(payload) {
  const response = await HTTP_GESCOM.post(URL_BASE + 'CreateAllAsync', payload);
  return response;
}

export async function updateAllAsync(payload) {
  const response = await HTTP_GESCOM.put(URL_BASE + 'UpdateAllAsync', payload);
  return response;
}
